import Vue from 'vue'
import VueI18n from 'vue-i18n'
import defaultLang from './lang'

Vue.use(VueI18n)

export default class I18n extends VueI18n {
  constructor (lang = {}) {
    const {
      locale,
      messages
    } = { ...defaultLang, ...lang }

    super({ locale, messages, fallbackLocale: 'de' })
  }
}
